/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type consultAnExpert_item$ref: FragmentReference;
export type consultAnExpert_item = {|
  +isJewelry: ?boolean,
  +getCategoriesByLevel: ?$ReadOnlyArray<?{|
    +label: ?string
  |}>,
  +pricing: ?{|
    +totalAmount: ?{|
      +convertedAmounts: ?{|
        +USD: ?number
      |}
    |}
  |},
  +$refType: consultAnExpert_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "consultAnExpert_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isJewelry",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "getCategoriesByLevel",
      "storageKey": "getCategoriesByLevel(level:2)",
      "args": [
        {
          "kind": "Literal",
          "name": "level",
          "value": 2,
          "type": "Int!"
        }
      ],
      "concreteType": "Category",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "label",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPricing",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "totalAmount",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "convertedAmounts",
              "storageKey": null,
              "args": null,
              "concreteType": "ConvertedAmounts",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "USD",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ac35e69fe3303a472958609a00575961';
module.exports = node;
